// Custom app-level TOTP MFA client — talks to the auth API (photohawk-serverless api-auth stack).
// This gates only the web app; it is NOT Cognito MFA, so FTP and the studio app are unaffected.
import { photohawkApi } from "@/lib/photohawkApi";

const opts = { service: "auth" as const };

export interface MfaStatus {
  enabled: boolean;
  pending?: boolean;
}

export const getMfaStatus = () => photohawkApi.get<MfaStatus>("mfa", opts);

// Begin enrolment: returns the shared secret + otpauth URI for the QR code.
export const enrollMfa = () =>
  photohawkApi.post<{ secret: string; otpauthUrl: string }>("mfa/enroll", opts);

// Confirm a code to switch MFA on.
export const enableMfa = (code: string) =>
  photohawkApi.post<{ enabled: boolean }>("mfa/enable", { ...opts, body: { code } });

// Login-time challenge.
export const verifyMfa = (code: string) =>
  photohawkApi.post<{ ok: boolean; enabled: boolean }>("mfa/verify", { ...opts, body: { code } });

// Turn MFA off (requires a current code).
export const disableMfa = (code: string) =>
  photohawkApi.post<{ enabled: boolean }>("mfa/disable", { ...opts, body: { code } });
